import React from 'react';

/**
 * The Loreto mark — the serif L over its rust rule, the same artwork as
 * /favicon.svg and the social avatar. The path is the traced outline of the
 * glyph (no font dependency), normalised into a 32x32 box so it drops straight
 * into the loader's viewBox alongside the orbiting arc.
 */
export const LORETO_L_PATH = 'M13.27 8.8 16.35 8.8 16.38 8.83 16.48 8.83 16.54 8.9 16.54 8.96 16.57 8.99 16.54 9.02 16.54 9.09 16.48 9.15 16.41 9.15 16.38 9.18 16.25 9.18 16.22 9.21 16.03 9.21 16.0 9.24 15.87 9.24 15.84 9.28 15.75 9.28 15.71 9.31 15.65 9.31 15.62 9.34 15.52 9.37 15.46 9.43 15.46 9.47 15.4 9.56 15.4 9.69 15.37 9.72 15.37 19.36 15.4 19.39 15.4 19.52 15.43 19.55 15.43 19.62 15.46 19.65 15.46 19.71 15.49 19.74 15.49 19.77 15.56 19.84 15.56 19.87 15.71 20.03 15.75 20.03 15.81 20.09 15.84 20.09 15.87 20.12 15.9 20.12 16.06 20.22 16.16 20.22 16.19 20.25 16.35 20.25 16.38 20.28 16.79 20.28 16.82 20.25 16.95 20.25 16.98 20.22 17.08 20.22 17.11 20.19 17.21 20.19 17.24 20.16 17.3 20.16 17.33 20.12 17.36 20.12 17.4 20.09 17.43 20.09 17.46 20.06 17.55 20.03 17.62 19.96 17.65 19.96 17.71 19.9 17.74 19.9 18.03 19.62 18.03 19.58 18.13 19.49 18.13 19.46 18.25 19.3 18.25 19.27 18.32 19.17 18.32 19.11 18.41 18.95 18.41 18.89 18.44 18.85 18.44 18.79 18.47 18.76 18.47 18.7 18.51 18.66 18.51 18.57 18.54 18.54 18.54 18.44 18.57 18.41 18.57 18.32 18.6 18.28 18.6 18.16 18.63 18.13 18.63 17.97 18.66 17.93 18.66 17.81 18.7 17.78 18.7 17.65 18.73 17.62 18.73 17.49 18.76 17.46 18.76 17.33 18.79 17.3 18.79 17.17 18.82 17.14 18.82 17.08 18.85 17.05 18.85 17.01 18.95 16.95 19.01 16.95 19.04 16.92 19.08 16.95 19.14 16.95 19.2 17.01 19.2 17.05 19.24 17.08 19.24 17.3 19.2 17.33 19.2 17.81 19.17 17.84 19.17 18.13 19.17 18.28 19.14 18.32 19.14 18.79 19.11 18.82 19.11 19.27 19.08 19.3 19.08 19.77 19.04 19.81 19.04 20.25 19.01 20.28 19.01 20.44 18.98 20.47 18.98 20.5 18.89 20.6 18.85 20.6 18.76 20.66 13.21 20.66 13.18 20.63 13.15 20.63 13.08 20.57 13.08 20.41 13.24 20.31 13.34 20.31 13.37 20.28 13.53 20.28 13.56 20.25 13.68 20.25 13.72 20.22 13.81 20.22 13.84 20.19 13.91 20.19 13.94 20.16 14.03 20.12 14.16 20.0 14.16 19.96 14.19 19.93 14.19 19.84 14.22 19.81 14.22 9.69 14.19 9.66 14.19 9.53 14.13 9.47 14.13 9.43 14.1 9.4 14.07 9.4 14.0 9.34 13.97 9.34 13.94 9.31 13.87 9.31 13.84 9.28 13.75 9.28 13.72 9.24 13.59 9.24 13.56 9.21 13.43 9.21 13.4 9.18 13.27 9.18 13.24 9.15 13.18 9.15 13.08 9.05 13.08 8.9 13.15 8.83 13.24 8.83 13.27 8.8Z';

// The rust rule under the L, in the same 32x32 space.
export const LORETO_RULE = { x: 11.24, y: 22.69, width: 9.52, height: 0.62 };

/**
 * The mark on its own, sized in px. Colours default to the brand pair but are
 * overridable so it can sit on a light surface.
 */
export default function LoretoGlyph({
  size = 32,
  glyph = 'var(--text)',
  rule = '#dd785f', // the rule colour sampled off the logo art itself
  className = '',
  title = 'Loreto',
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      role="img"
      aria-label={title}
    >
      {/* The path is normalised small so the loader can orbit an arc around
          it; on its own the mark should fill its box, hence the scale-up. */}
      <g transform="translate(16 16) scale(1.8) translate(-16 -16)">
        <path fill={glyph} d={LORETO_L_PATH} />
        <rect {...LORETO_RULE} fill={rule} />
      </g>
    </svg>
  );
}
